export default __webpack_public_path__ + "static/media/pay 3.e221a908.png";